module.exports = __webpack_public_path__ + "static/media/2025_nuna_law.2ae49ff7.pdf";